//This file holds the notes array used by the todos section and the 
//methods that act upon it.

import {v4 as uuidv4} from 'uuid'  //Note renamed import

//The todos array.
//NOTE: Due to the nature of web programming, each webpage has its 
//own copy this array. The copies must be kept consistant by the 
//storage callback functions.
let todos;

//Function to load todos and keep storage consistant.
const loadTodos = () => {
    //Get stored notes an JSON.
    const todosJSON = localStorage.getItem('todos');

    //Try to parse notes.
    try {
        todos = todosJSON ? JSON.parse(todosJSON) : [];
    } catch (e) {
        todos = [];
    }
}

//Function to save todos. (NOT exported.)
const saveTodos = () => {
    localStorage.setItem('todos', JSON.stringify(todos));
}

//Function to get all saved notes.
const getTodos = () => todos;

//Function to create a new todo.
const createTodo = (text) => {
    //Add new item to array.
    todos.push({
        id: uuidv4(),
        text,   //Shorthand for text: text
        completed: false
    });

    //Update local storage.
    saveTodos();
}

//Function delete a todo by unique ID field.
const removeTodo = (id) => {
    const index = todos.findIndex((todo) => todo.id === id);

    if (index > -1) {
        //A todo has been found.
        todos.splice(index, 1);
    }

    //Update local storage.
    saveTodos();    
}

//Function to change status of todo by unique ID field.
const toggleTodo = (id) => {
    const foundTodo = todos.find((todo) => todo.id === id);

    if (foundTodo !== undefined) {
        //A todo has been found.
        foundTodo.completed = !foundTodo.completed;
    }

    //Update local storage.
    saveTodos();    
}

//Do initial data load.
loadTodos();

//Export functions.
export {getTodos, createTodo, removeTodo, loadTodos, toggleTodo};